module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h-2"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PREFACE: WHAT "), _c('em', [_vm._v("IS")]), _vm._v(" LIBERAL CHRISTIANITY?")]), _vm._v(" "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_07_preface#pref"
    }
  }, [_vm._v("vii")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("            PART ONE: HOW A LIBERAL CHRISTIAN LOOKS AT RELIGION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_vm._v("Chapter 1   Some Liberal Perspectives: Jesus, Science, Abortion, and Same-Sex Marriage   "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_09_chap01#chap01"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_vm._v("Chapter 2   The Essence of Liberal Christianity   "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_10_chap02#chap02"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_vm._v("Chapter 3   God   "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_11_chap03#chap03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_vm._v("Chapter 4   Jesus and the Church   "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_12_chap04#chap04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_vm._v("Chapter 5   Understanding the Bible   "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_13_chap05#chap05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_vm._v("Chapter 6   Faith   "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_14_chap06#chap06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_vm._v("Chapter 7   Talking to Atheists and Christian Conservatives   "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_15_chap07#chap07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("            PART TWO: A LIBERAL CHRISTIAN QUESTIONS SOCIETY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_vm._v("Chapter 8   The Great Social Issues: Poverty, Bigotry, War, and Environmental Destruction   "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_17_chap08#chap08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_vm._v("Chapter 9   Church and State   "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_18_chap09#chap09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("            PART THREE: LIVING THE LIBERAL CHRISTIAN LIFE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_vm._v("Chapter 10   Christian Doctrine: The Trinity, Communion, Being Born Again, the Apocalypse, and the Sabbath   "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_20_chap10#chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("177")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_vm._v("Chapter 11   The Church Year: Advent, Christmas, Holy Week, and Easter   "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_21_chap11#chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("199")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EPILOGUE RECLAIMING LIBERAL CHRISTIANITY")]), _vm._v(" "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_22_epilogue#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("215")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_23_ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("227")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SUGGESTIONS FOR FURTHER READING")]), _vm._v(" "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_24_furreading#fur"
    }
  }, [_vm._v("228")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOTES")]), _vm._v(" "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_25_notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("231")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-Chapter"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INDEX")]), _vm._v(" "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/9780230240582_26_index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("254")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b640b4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780230240582_05_contents.vue
// module id = 69
// module chunks = 0